module.exports = __webpack_public_path__ + "static/media/banner-news-robo.a76faebf.png";